import { render, staticRenderFns } from "./FactorDocumentsView.vue?vue&type=template&id=06eed5f4&scoped=true&"
import script from "./FactorDocumentsView.vue?vue&type=script&lang=ts&"
export * from "./FactorDocumentsView.vue?vue&type=script&lang=ts&"
import style0 from "./FactorDocumentsView.vue?vue&type=style&index=0&id=06eed5f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06eed5f4",
  null
  
)

export default component.exports